// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"7221ac2b","277":"ca10f1c7","352":"d502747f","371":"40bda783","708":"380e8c99","710":"7a9989c7","733":"8378b544","782":"44dd5738","846":"d4763822","929":"7f1e47b2"}[chunkId] + ".chunk.js";
};